module.exports = __webpack_public_path__ + "static/logo-thewitcher-dark-pl@2x-89a6c9003276a1c6a8c2b4697bcf1e25.png";